import { render, staticRenderFns } from "./addChildWorks.vue?vue&type=template&id=94e033ec&"
import script from "./addChildWorks.vue?vue&type=script&lang=js&"
export * from "./addChildWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports